module.exports = __webpack_public_path__ + "static/media/warpaws.abb7a12d.png";